import React from 'react'

export default function ModeRail({ style, svgStyle }: any) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgStyle}
    >
      <path
        fill="#212121"
        fillRule="evenodd"
        clipRule="evenodd"
        {...style}
        d="M7 3.98333H8.8L9.4 2.56667C9.5 2.28333 9.9 2 10.3 2H13.7C14.1 2 14.5 2.28333 14.6 2.56667L15.2 3.98333H17C18.3 3.98333 19.4 4.83333 19.4 5.77778V15.7889C19.4 16.7333 18.6 17.3944 17.5 17.5833V18.3389L21 22.0222H19L18.5 21.55H5.5L5 22.0222H3L6.5 18.3389V17.5833C5.4 17.3944 4.6 16.7333 4.6 15.7889V5.77778C4.6 4.83333 5.7 3.98333 7 3.98333ZM8.9 17.5833H15.1V18.2444H8.9V17.5833ZM12 2.56667C12.4 2.56667 12.8 2.94444 12.8 3.32222C12.8 3.79444 12.4 4.07778 12 4.07778C11.6 4.07778 11.2 3.79444 11.2 3.32222C11.2 2.94444 11.6 2.56667 12 2.56667ZM15.6 4.73889H8.4C8.2 5.02222 8.3 5.4 8.8 5.4H15.2C15.7 5.4 15.8 5.02222 15.6 4.73889ZM7.4 13.8056C8.2 13.8056 8.8 14.3722 8.8 15.1278C8.8 15.8833 8.2 16.45 7.4 16.45C6.6 16.45 6 15.8833 6 15.1278C6 14.3722 6.6 13.8056 7.4 13.8056ZM16.6 13.8056C17.4 13.8056 18 14.3722 18 15.1278C18 15.8833 17.4 16.45 16.6 16.45C15.8 16.45 15.2 15.8833 15.2 15.1278C15.2 14.3722 15.8 13.8056 16.6 13.8056ZM17.5 20.4167L16.4 19.2833H7.6L6.5 20.4167H17.5ZM6.4 5.96667H17.6C18 5.96667 18.3 6.25 18.3 6.53333V10.1222C18.3 10.4056 18 10.6889 17.6 10.6889H6.4C6 10.6889 5.7 10.4056 5.7 10.1222V6.53333C5.7 6.25 6 5.96667 6.4 5.96667Z"
      />
    </svg>
  )
}
